import { render } from "./userLayout.vue?vue&type=template&id=e1cd285e"
import script from "./userLayout.vue?vue&type=script&lang=js"
export * from "./userLayout.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\angren\\qabul_auniver\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__